<template lang="html">
    <div class="inner-content">

        <div class="fourColumnGrid">
            <tl-select label="Paygroups" :options="paygroupsOptions" v-model="formData.payGroup" @change="(val)=>formData.payGroup = val"
                name="Pay Groups" :classname="errors.has('Pay Groups')" v-validate="'required'" :errormsg="errors.first('Pay Groups')"></tl-select>

            <tl-select label="Department" :options="departmentOptions" v-model="formData.department" @change="(val)=>formData.department = val"
                name="Department" :classname="errors.has('Department')" v-validate="'required'" :errormsg="errors.first('Department')"></tl-select>

            <tl-select label="Designation" :options="designationOptions" v-model="formData.designation" @change="(val)=>formData.designation = val"
                name="Designation" :classname="errors.has('Designation')" v-validate="'required'" :errormsg="errors.first('Designation')"></tl-select>

            <btn class="filter-btn" text="Apply Filters" type="secondary" @click="backToDashboard" />
        </div>

        <div class=" margin-top-30">
            <tl-search @change="filterData" />
        </div>

        <div class="margin-top-35">
            <data-table :columns="employeeTableColumns" :tableData="employeeData" :checkbox="true" :withForm="false" :showinrow="false"
                @download="downloadItem" @delete="deleteItem" @editStart="initEditStart" @update="updateItem" @selected="selectedItem"
                @deselected="deselectItem" :search="search">
                <template v-slot:rowcontent="slotprops">
                    <img class="sm-img" v-if="slotprops.value.column.key=='imgSrc'" :src="slotprops.value.record[slotprops.value.column.key]">
                    <p v-if="slotprops.value.column.key!='imgSrc'">{{slotprops.value.record[slotprops.value.column.key]}}</p>
                    <!-- <button v-if="slotprops.value.column.key=='action'" class="action-img" v-on:click="edit(slotprops.value.record)">
                       <img src="@/assets/download.svg" class="Group-5" />
                  </button> -->
                </template>
            </data-table>
        </div>

        <bottom-action-container class="custom-width">
            <template slot="end">
                <btn-grp>
                    <btn text="Back To Dashboard" type="secondary" @click="backToDashboard" />
                </btn-grp>
            </template>
        </bottom-action-container>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from "vuex";

    export default {
        name: "fbpClaimsDirectory",
        computed: {
            ...mapState({}),
            ...mapGetters({
                orgid: "onboard/organization/orgid"
            })
        },
        data() {
            return {
                employeeTableColumns: [
                    {
                        label: "",
                        key: "imgSrc"
                    },
                    {
                        label: "Code",
                        key: "code"
                    },
                    {
                        label: "Name",
                        key: "name"
                    },
                    {
                        label: "Department",
                        key: "department"
                    },
                    {
                        label: "Email ID",
                        key: "email"
                    },
                    {
                        label: "Location",
                        key: "location"
                    }
                ],
                employeeData: [
                    {
                        id: 1,
                        code: "RC1234",
                        name: "Roxi",
                        department: "IT",
                        email: "Roxi@gmail.com",
                        noofDocs: 5,
                        essstatus: "Active",
                        imgSrc: require("@/assets/user.svg"),
                        action: "",
                        department:"IT",
                        location: "South Sigmud"
                    },
                    {
                        id: 2,
                        code: "RC1234",
                        name: "Roxi",
                        department: "IT",
                        email: "Roxi@gmail.com",
                        noofDocs: 10,
                        essstatus: "Active",
                        imgSrc: require("@/assets/user.svg"),
                        action: "",
                        department:"IT",
                        location: "South Sigmud"
                    },
                    {
                        id: 3,
                        code: "RC1234",
                        name: "Roxi",
                        department: "IT",
                        email: "Roxi@gmail.com",
                        noofDocs: 15,
                        essstatus: "Active",
                        imgSrc: require("@/assets/user.svg"),
                        action: "",
                        department:"IT",
                        location: "South Sigmud"
                    }
                ],
                paygroupsOptions: [],
                departmentOptions: ["HR", "Accountant", "TeamLead"],
                designationOptions: ["Project Manager", "Designation1", "Designation2"],

                statusData: ["Complete", "In-Complete", "Blocked"],

                formData: {
                    payGroup: '',
                    department: '',
                    designation: ''
                }
            };
        },
        mounted() { },

        methods: {
            ...mapActions({}),

            filterData() { },

            backToDashboard() { },
        }
    };
</script>

<style lang="scss" scoped>
    .fourColumnGrid {
        grid-template-columns: 16% 16% 16% 9%;
    }

    .filter-btn {
        min-width: 95px;
        min-height: 35px;
        font-family: Montserrat;
        font-size: 12px;
        font-weight: 600;
        padding: 8px;
        margin-top: 19px;
    }

    .margin-top-30 {
        margin-top: 30px;
    }

    .margin-top-35 {
        margin-top: 35px;
    }

    .search-container {
        width: 33.3%;
        position: relative;
        max-width: 33.3%;
    }

.custom-width {
        width: 86%;
    }
</style>